import React from 'react';
import {CLoadingButton} from '@coreui/react-pro';

const MapLoadingSpinner = (props) => {

  return (    
    <CLoadingButton
      loading={true}
      style={{backgroundColor: 'white', color: '#00244B',}}
      spinnerType='grow'
      variant='outline'>
      {props.loadingText}
    </CLoadingButton>
  );
}

export default MapLoadingSpinner;
